module.exports = __webpack_public_path__ + "media/images/prizes/right_points-840b31f63a37151e109905c7f2accd47.svg";